import { Link } from 'react-router-dom'
import { MapPin, Navigation, Loader2, Search } from 'lucide-react'

/** First-run / no-location state: ask permission or fall back to a default place. */
export function LocationPrompt({
  locating,
  error,
  onLocate,
  onUseDefault,
}: {
  locating: boolean
  error: string | null
  onLocate: () => void
  onUseDefault: () => void
}) {
  return (
    <div className="locate card">
      <div className="locate__ring">
        <MapPin size={28} />
      </div>
      <h1 className="locate__title">Your sky, at a glance</h1>
      <p className="locate__sub">
        Allow location for live conditions, the forecast, and warnings where you are.
      </p>

      {error && <p className="locate__error">{error}</p>}

      <button className="btn btn--primary" onClick={onLocate} disabled={locating}>
        {locating ? <Loader2 className="spin" size={18} /> : <Navigation size={18} />}
        {locating ? 'Locating…' : 'Use my location'}
      </button>
      <Link to="/locations" className="btn btn--ghost">
        <Search size={17} /> Search a city
      </Link>
      <button className="btn btn--ghost" onClick={onUseDefault} disabled={locating}>
        Skip for now
      </button>
    </div>
  )
}
